function t(e, a) {
  return e.name === a.name && e.size === a.size && e.lastModified === a.lastModified;
}
export {
  t as areFilesDuplicate
};
